import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@features/auth';
import { useAuth } from '@features/auth';
import authRoutes from './routes/authRoutes';
import hotelRoutes from './routes/hotelRoutes';
import dealRoutes from './routes/dealRoutes';
import miscRoutes from './routes/miscRoutes';

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  // Routes that should be publicly accessible without authentication
  const publicMiscPaths = ['/', '*', '/about', '/privacy', '/terms'];

  const filteredMiscRoutes = miscRoutes.filter(route =>
    !publicMiscPaths.includes(route.props.path)
  );

  // Public legal pages (About, Privacy, Terms)
  const publicLegalRoutes = miscRoutes.filter(route =>
    ['/about', '/privacy', '/terms'].includes(route.props.path)
  );

  return (
    <Routes>
      {/* Public Routes */}
      {authRoutes.filter(route =>
        route.props.path === '/login' ||
        route.props.path === '/signup' ||
        route.props.path === '/forgot-password' ||
        route.props.path === '/reset-password'
      )}

      {/* Public Legal Pages - accessible without authentication */}
      {publicLegalRoutes}

      {/* Landing page - redirect to dashboard if authenticated */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            miscRoutes.find(route => route.props.path === '/')?.props.element
          )
        }
      />

      {/* Debug route - only in development */}
      {(process.env as unknown as Record<string, string | undefined>).NODE_ENV === 'development' &&
        authRoutes.find(route => route.props.path === '/auth-debug')}

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        {/* Hotel Routes */}
        {hotelRoutes}

        {/* Deal Routes */}
        {dealRoutes}

        {/* Misc Routes (except landing and catch-all) */}
        {filteredMiscRoutes}
      </Route>

      {/* Catch-all route */}
      {miscRoutes.find(route => route.props.path === '*')}
    </Routes>
  );
};

export default AppRoutes;
